import React from 'react';
import Img from '@/components/Img';
import styles from './Benefits.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import { mediaPath } from '@/mediaPath';

type BenefitProps = {
  title: string;
  button?: {
    title: string;
    link: string;
    type: ButtonType;
  };
  cards: {
    id: number;
    title: string;
    subtitle: string;
    icon: {
      url: string;
    };
  }[];
};

const Benefits = ({ data }: { data: BenefitProps }) => (
  <section className={styles.benefits}>
    <h2 className={styles.title}>{data.title}</h2>

    <ul className={styles.benefitsList}>
      {data.cards.map((card) => (
        <li
          key={card.id}
          className={styles.benefitCard}
        >
          <Img
            local
            className={styles.image}
            src={mediaPath(card.icon.url)}
            height={235}
            width={387}
          />
          <div className={styles.textContent}>
            <h4>{card.title}</h4>
            <p>{card.subtitle}</p>
          </div>
        </li>
      ))}
    </ul>
    {data.button && (
      <Button
        className={styles.cta}
        type={data.button.type}
        fitContent
        href={data.button.link}
      >
        {data.button.title}
      </Button>
    )}
  </section>
);

export default Benefits;
